export default __webpack_public_path__ + "static/media/landing1.c06aaa6e.png";